import { render, staticRenderFns } from "./find-campana.vue?vue&type=template&id=45c75cfe"
import script from "./find-campana.vue?vue&type=script&lang=ts"
export * from "./find-campana.vue?vue&type=script&lang=ts"
import style0 from "./find-campana.vue?vue&type=style&index=0&id=45c75cfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports